"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _immutable = require("immutable");

var formatIntegrationPropertyReference = function formatIntegrationPropertyReference(properties, id) {
  return new _ReferenceRecord.default({
    id: id,
    label: id + "-properties",
    referencedObject: (0, _immutable.fromJS)({
      id: id,
      properties: properties
    })
  });
};

var formatIntegrationProperties = function formatIntegrationProperties(response) {
  return (0, _immutable.Map)(response.eventTypeIdProperties).map(formatIntegrationPropertyReference);
};

var _default = formatIntegrationProperties;
exports.default = _default;
module.exports = exports.default;